var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import ThicknessSelect from "../../components/articleattributes/thicknessselect.vue";
import { thicknessConfig, } from "../utilities/thickness";
let ThicknessElement = class ThicknessElement extends Vue {
    input(value) {
        return value;
    }
    get elementKey() { return "thickness"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get selectedValue() {
        return {
            name: this.i18n.numberWithTwoDecimals(this.value),
            number: this.value,
            invalid: undefined,
        };
    }
    get thicknessConfig() {
        return thicknessConfig(this.shopConfig, this.bendPart, this.value, this.i18n);
    }
};
__decorate([
    Prop({ required: true })
], ThicknessElement.prototype, "bendPart", void 0);
__decorate([
    Prop({ required: true })
], ThicknessElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], ThicknessElement.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], ThicknessElement.prototype, "value", void 0);
__decorate([
    Inject()
], ThicknessElement.prototype, "i18n", void 0);
__decorate([
    Inject()
], ThicknessElement.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], ThicknessElement.prototype, "input", null);
ThicknessElement = __decorate([
    Component({
        components: {
            EditDataElementLabel,
            ThicknessSelect,
        },
        name: "ThicknessElement",
    })
], ThicknessElement);
export default ThicknessElement;
